export default "__VITE_ASSET__73ddfa1e__"